import { Form, Select, Table, Button, Space, Tag, Popconfirm, message } from 'antd';
import { EditOutlined, DeleteOutlined, InboxOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';

import WorkflowManagementAPI from '../../../restAPI/WorkflowManagementAPI';
import { useNavigate } from 'react-router-dom';
import CommonSkeletonLoader from '../../../helperComponents/CommonSkeleton';


export default function Draft({ tabValue, searchText }) {
     const navigate = useNavigate();
    //console.log('Draft')
    const tabKey = 3;
    const [payload, setPayload] = useState([]);
    const [isStateChanged, setIsStateChanged] = useState(false);
    //const navigate = useNavigate(); // Initialize the useNavigate hook
    const { companyId, token, userCompany } = useSelector(state => state.auth);
    const [isDraftListLoading, setDraftListLoading] = useState(false);
    
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        setDraftListLoading(true);
        getApprovalRequestsData();
    }, [companyId, tabValue]);

    useEffect(() => {
        getApprovalRequestsData();
    }, [isStateChanged]);

    const getApprovalRequestsData = async () => {
        await WorkflowManagementAPI.getApprovalRequests(tabKey, companyId, token).then((res) => {

            var dataList = res.data
            dataList.forEach(element => {
                let changeDate = new Date(element['createdAt']).toLocaleString()
                element['createdAt'] = changeDate
            });
            setPayload(dataList)
            setDraftListLoading(false);
        }).catch((err) => {
            setDraftListLoading(false);
        }).finally(() => {

        })
    };


    const columns = [
        {
            title: 'Circulated On',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text) => {
                const date = new Date(text);
                const dateString = date.toLocaleDateString(); 
                const timeString = date.toLocaleTimeString(); 
                return (
                    <span>
                        {dateString}
                        <br />
                        {timeString}
                    </span>
                );
            },
        },
        {
            title: 'Initiator',
            dataIndex: ['createdBy', 'name'],
            key: 'initiator',
        },
        {
            title: 'Subject Line',
            dataIndex: 'subject',
            key: 'subject',
        },
        {
            title: 'Request Type',
            dataIndex: ['requestType', 'requestType'],
        },
        {
            title: 'Action',
            key: 'actionButtons',
            align: 'center',
            render: (_, record) => (
                <Popconfirm
                        title="Delete"
                        description="Are you sure you wish to delete this?"
                        onConfirm={() => onClickDeleteButton(record._id)}
                        okText="Yes"
                        cancelText="No"
                    >
                    <Button icon={<DeleteOutlined />} 
                        //onClick={() => onClickDeleteButton(record._id)} 

                        style={{ display: 'inline-block'}} danger type="default" title='Delete' />
                </Popconfirm>
            ),
        },
    ];

    const onClickDeleteButton = async (data) => {
            setIsStateChanged(false)
    
            try {
                await WorkflowManagementAPI.deleteApprovalRequest(data, companyId, token).then((res) => {
                    setIsStateChanged(true)
                })
            } catch (err) {
                messageApi.open({
                    type: 'error',
                    content: err.message,
                });
            }
    
        }

    return (
        <>
            <>
                    {contextHolder}
            </>
            {
                isDraftListLoading ? (<>
                    <CommonSkeletonLoader itemCount={2} />
                </>) : (<>
                    <Table dataSource={payload} columns={columns} pagination={false} 
                        onRow={(record) => ({
                            onClick: (e) =>{
                                const cell = e.target.closest('td');
                                const colIndex = cell?.cellIndex;
                                if(colIndex !== 4 && colIndex){
                                    navigate('/work-flow/edit-approval-request', { state: record });
                                }
                            }   
                        })}
                        style={{
                            cursor: 'pointer',
                        }}
                    />
                </>)
            }
        </>
    );
}
